// @constants
const {
    EURO_TEXT,
    CHECKING_ACCOUNT_CODE,
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK1,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK1_ID,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK2,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK2_ID,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK3,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK3_ID,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK4,
    CARD_REVOLVING_PRODUCT_SUBTYPE_PACK4_ID,
} = require('constants/index');
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');

const getAccountForHire = (immAccounts, immAccountIDs, interventionTypes) => {
    const accountsIndexes = immAccountIDs.filter(accountId =>
        // We remove the accounts that are not in euros
        immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
    ).filter(accountId =>
        // We remove the accounts that don't comply with the requisites of product type and subtype
        immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
        ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
    ).filter(accountId =>
        // We remove the accounts where the user is not the owner
        interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
    );

    // We return an Immutable with the ids of the filtered accounts
    return accountsIndexes;
}

const ownerFromAccount = immAccounts => {
    const interventionTypes = [
        ACCOUNT_INTERVENTION_OWNER,
        ACCOUNT_INTERVENTION_CO_OWNER,
        ACCOUNT_INTERVENTION_REPRESENTATIVE
    ];

    const accountsIndexes = getAccountForHire(immAccounts, immAccounts.get('byOrder'), interventionTypes);

    return !accountsIndexes.isEmpty();
}

const revolvingSubType = {
    [CARD_REVOLVING_PRODUCT_SUBTYPE_PACK1_ID]: CARD_REVOLVING_PRODUCT_SUBTYPE_PACK1,
    [CARD_REVOLVING_PRODUCT_SUBTYPE_PACK2_ID]: CARD_REVOLVING_PRODUCT_SUBTYPE_PACK2,
    [CARD_REVOLVING_PRODUCT_SUBTYPE_PACK3_ID]: CARD_REVOLVING_PRODUCT_SUBTYPE_PACK3,
    [CARD_REVOLVING_PRODUCT_SUBTYPE_PACK4_ID]: CARD_REVOLVING_PRODUCT_SUBTYPE_PACK4,
}

const getRevolvingSubType = (pack) => revolvingSubType[pack];

module.exports = {
    getAccountForHire,
    getRevolvingSubType,
    ownerFromAccount,
}
